import { filterFlavors, filterFlavorsWithoutCatFours } from 'utils/filters';
import { useEffect, useState } from 'react';
import { CATEGORY_FILTERS } from '@/config/constants';
import { FLAVORS_METADATA } from 'components/FlavorFilters/utils';
import { useFetchFlavors } from './api';

const filterSortKeyAccesor = (sortOption) => sortOption.value;

export const useSetupFlavorFilters = ({
    defaultHandleFilter,
    defaultFilterAccessorsAndOptions,
}) => {
    const [filterAccessorsAndOptions, setFilterAccessorsAndOptions] = useState(
        defaultFilterAccessorsAndOptions,
    );
    const [handleFilter, setHandleFilter] = useState(defaultHandleFilter);
    const [handleFiltersWithoutCatFours, setHandleFiltersWithoutCatFours] =
        useState({});
    const flavorsQuery = useFetchFlavors();
    const flavorsOptions = flavorsQuery.data?.flavorsOptions || [];
    useEffect(() => {
        if (flavorsOptions?.length) {
            setHandleFilter({ ...defaultHandleFilter, flavors: filterFlavors });
            setHandleFiltersWithoutCatFours({
                ...defaultHandleFilter,
                flavors: filterFlavorsWithoutCatFours,
            });
            setFilterAccessorsAndOptions({
                ...defaultFilterAccessorsAndOptions,
                flavors: {
                    accessor: filterSortKeyAccesor,
                    options: flavorsOptions,
                },
            });
        }
    }, [flavorsOptions, defaultHandleFilter, defaultFilterAccessorsAndOptions]);

    return {
        handleFilter,
        filterAccessorsAndOptions,
        handleFiltersWithoutCatFours,
    };
};

const supportsFilter = (category, filterType) => {
    return CATEGORY_FILTERS[category]?.includes(filterType);
};

export const useAreFlavorFiltersSupported = ({ categoryQuery = {} }) => {
    const hierarchy = categoryQuery?.data?.[0]?.hierarchies?.[0]?.[1];
    return supportsFilter(hierarchy?.cat1, 'flavors');
};

export const useHandleAreFlavorFiltersSupported = ({
    categoryQuery = {},
    filters,
    setFilters,
}) => {
    const hierarchy = categoryQuery?.data?.[0]?.hierarchies?.[0]?.[1];
    const isFlavorFilterSupported = supportsFilter(hierarchy?.cat1, 'flavors');
    const isLoaded =
        categoryQuery?.data?.length && categoryQuery.data[0].hierarchies;

    useEffect(() => {
        if (!isLoaded) return;

        if (!isFlavorFilterSupported && filters?.flavors) {
            const { flavors, ...filtersWithoutFlavors } = filters;
            setFilters(filtersWithoutFlavors);
        }
    }, [categoryQuery.data, filters]);

    return isFlavorFilterSupported;
};

export const useResetSortOptionFlavorUnsupported = ({
    categoryQuery,
    areFlavorFiltersSupported,
    sortOptionKey,
    setSupportedSortOption,
    defaultInitialSortOption,
}) => {
    const isLoaded =
        categoryQuery?.data?.length && categoryQuery.data[0].hierarchies;
    useEffect(() => {
        if (!isLoaded) return;
        if (
            !areFlavorFiltersSupported &&
            sortOptionKey.includes(FLAVORS_METADATA.key)
        ) {
            setSupportedSortOption(defaultInitialSortOption);
        }
    }, [areFlavorFiltersSupported, categoryQuery?.data, sortOptionKey]);
};
